import React from "react";

const RightArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
      <g fill="none" fill-rule="evenodd">
        <path
          fill="#FEC10D"
          fill-rule="nonzero"
          d="M0 33C0 14.775 14.78 0 33.013 0c18.233 0 33.014 14.775 33.014 33-.015 18.22-14.787 32.985-33.014 33C14.781 66 0 51.225 0 33z"
        />
        <path
          fill="#191B1D"
          d="m41.932 31.82-11.319-7.323a2 2 0 0 0-3.086 1.68v14.647a2 2 0 0 0 3.086 1.679l11.319-7.324a2 2 0 0 0 0-3.358z"
        />
      </g>
    </svg>
  );
};

export default RightArrow;
